<template>
    <vs-card class="tab_with_btn_holder">
        <vs-tabs>
            <vs-tab label="Invoice">
                <Payslip />
            </vs-tab>
            <vs-tab label="Payments Settings">
                <Settings />
            </vs-tab>
        </vs-tabs>
    </vs-card>
</template>

<script>
import Payslip from './payslip.vue'
import Settings from './settings.vue'

export default {
  components: {
    Payslip,
    Settings
  }
}
</script>